import { z } from 'zod';
import {
  analysisSummarySchema,
  confirmedFactSchema,
  designDecisionSchema,
  designGoalSchema,
  designGoalStatusSchema,
  designMissionSchema,
  designQuestionSchema,
  designReadinessSchema,
  workflowPlanSchema,
} from './design-session.ts';

export const designCommandSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('mission.set'),
    mission: designMissionSchema,
  }).strict(),
  z.object({
    type: z.literal('plan.replace'),
    plan: workflowPlanSchema,
  }).strict(),
  z.object({
    type: z.literal('plan.active.set'),
    goalId: z.string().min(1).nullable(),
    updatedAt: z.string().datetime(),
  }).strict(),
  z.object({
    type: z.literal('goal.upsert'),
    goal: designGoalSchema,
  }).strict(),
  z.object({
    type: z.literal('goal.status.set'),
    goalId: z.string().min(1),
    status: designGoalStatusSchema,
    transitionReason: z.string().optional(),
    updatedAt: z.string().datetime(),
  }).strict(),
  z.object({
    type: z.literal('question.ask'),
    question: designQuestionSchema,
  }).strict(),
  z.object({
    type: z.literal('question.resolve'),
    questionId: z.string().min(1),
    status: z.enum(['answered', 'superseded']),
    answerFactId: z.string().min(1).optional(),
    resolvedAt: z.string().datetime(),
  }).strict(),
  z.object({
    type: z.literal('fact.confirm'),
    fact: confirmedFactSchema,
  }).strict(),
  z.object({
    type: z.literal('analysis.record'),
    analysis: analysisSummarySchema,
  }).strict(),
  z.object({
    type: z.literal('decision.record'),
    decision: designDecisionSchema,
  }).strict(),
  z.object({
    type: z.literal('readiness.update'),
    readiness: designReadinessSchema,
  }).strict(),
]);

export const workflowEventSchema = z.object({
  eventId: z.string().min(1),
  turnId: z.string().min(1),
  createdAt: z.string().datetime(),
  type: z.literal('workflow.commands'),
  sessionId: z.string().min(1),
  baseRevision: z.number().int().nonnegative(),
  commands: z.array(designCommandSchema).min(1),
}).strict();

export type DesignCommand = z.infer<typeof designCommandSchema>;
export type WorkflowEvent = z.infer<typeof workflowEventSchema>;
